module.exports = __webpack_public_path__ + "static/img/banner-session-bienvenida-1024x768.404d1b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-session-bienvenida-1024x768.jpg
// module id = bVhN
// module chunks = 47